import React from 'react';
import classNames from 'classnames';
/**
 * Bronson Checkbox component.
 *
 * @see https://bronson.vwfs.tools/default/components/detail/bronson-checkbox.html
 *
 * @constructor
 */
export function Checkbox({ children, className, error, id, required, requiredText, testId, ...otherProps }) {
    const labelClassNameList = classNames('c-checkbox', className).trim();
    const inputClassNameList = classNames('c-checkbox__input').trim();
    /**
     * If {@link required} is set, render a `required` flag according {@link requiredText}.
     */
    function renderIfRequired(required, requiredText) {
        return required ? React.createElement("span", { "aria-hidden": "true" }, requiredText) : null;
    }
    return (React.createElement("label", { className: labelClassNameList, htmlFor: id },
        React.createElement("input", { id: id, className: inputClassNameList, type: "checkbox", "aria-invalid": error ? true : undefined, required: required ? true : undefined, "data-testid": testId, ...otherProps }),
        React.createElement("span", { className: "c-checkbox__label" },
            children,
            renderIfRequired(required, requiredText))));
}
